export const REQUEST_STATUS_CHANGE = 'components/RequestStatus/request_status_change'



// WEBPACK FOOTER //
// ./src/components/RequestStatus/constants.js